class AnalyticsException {
  /**
   * Create an instance of the class
   *
   * @param {String} message
   */
  constructor (message) {
    this.message = message;
  }
}

module.exports = AnalyticsException;
